import React from "react";
import { Button, Modal } from "antd";
import moment from "moment";
import "./style.scss";
import UserProfile from "./";
import {
  SAVE_USER_FORM_REQUEST_ACTION,
  SAVE_USER_FORM_SUCCESS_ACTION,
  SAVE_USER_FORM_FAILURE_ACTION
} from "../../ducks/user";
import { addSubmitForm } from "../../ducks/app";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const _ = require("lodash");
const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    return {};
  };

  return mapStateToProps;
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addSubmitForm
    },
    dispatch
  );

@connect(
  makeMapStateToProps,
  mapDispatchToProps
)
class EditUserModal extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.show !== this.props.show && this.props.show) {
      if (this.props.user && this.props.user.type) {
        this.props.addSubmitForm(this.props.user);
      }
    }
  }
  render() {
    let title = "User";
    return (
      <Modal
        title={title}
        wrapClassName="vertical-center-modal"
        visible={this.props.show}
        width={600}
        onCancel={this.props.onCancel}
        footer={null}
      >
        <UserProfile
          key={this.props.key}
          user={this.props.user}
          locations={this.props.locations}
          onCancel={this.props.onCancel}
          onSave={this.props.onSave}
          patientConditionId={this.props.patientConditionId}
          patientId={this.props.patientId}
          userRole={this.props.userRole}
          showRole={this.props.showRole}
          startActionType={SAVE_USER_FORM_REQUEST_ACTION.getType()}
          resolveActionType={SAVE_USER_FORM_SUCCESS_ACTION.getType()}
          rejectActionType={SAVE_USER_FORM_FAILURE_ACTION.getType()}
        />
      </Modal>
    );
  }
}

export default EditUserModal;



// WEBPACK FOOTER //
// ./src/components/Profile/modal.js